import { Clock, ScrollText } from "lucide-react";

import type { Contract } from "@/types/contract";

import { formatCurrency, formatDate } from "@/lib/utils";

import { Button } from "../ui/button";
import { DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { StatusTag } from "./status-tag";

export function ViewContract({ contract, handleNext }: { contract: Contract; handleNext: () => void }) {
	const total = contract.contractItem.reduce((sum, item) => sum + item.totalCost, 0);

	return (
		<>
			<DialogHeader className="flex-row items-start justify-between space-y-0">
				<DialogTitle className="sr-only">Order Receipt</DialogTitle>
				<DialogDescription className="sr-only">View Contract</DialogDescription>
				<div className="flex items-start gap-4">
					<div className="rounded-lg bg-indigo-600 p-3">
						<ScrollText className="h-8 w-8 text-white/90" />
					</div>
					<div>
						<div className="flex items-center gap-2">
							<h2 className="text-xl font-semibold capitalize">{contract.title}</h2>
							{/* @ts-expect-error TODO fizx thie status tag */}
							<StatusTag status={contract.status.toLowerCase()} />
						</div>
						<p className="text-sm text-gray-500">
							CONTRACT ID:
							{contract.contractCode}
						</p>
					</div>
				</div>
			</DialogHeader>

			<div className="space-y-6">
				<div className="flex items-center justify-between text-sm text-gray-500">
					<span>{formatDate(contract.createdAt)}</span>
					<span>
						{new Date(contract.createdAt).toLocaleTimeString("en-US", {
							hour: "numeric",
							minute: "numeric"
						})}
					</span>
				</div>

				<div className="space-y-4">
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Item</TableHead>
								<TableHead>Qty</TableHead>
								<TableHead className="text-right">Amount</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{contract.contractItem.map(item => (
								<TableRow key={item.id} className="bg-white border-b">
									<TableCell>{item.productId.name}</TableCell>
									<TableCell>{item.productQuantity}</TableCell>
									<TableCell className="text-right">
										{formatCurrency(item.totalCost, "NGN")}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>

					<div className="flex justify-between border-t pt-4 font-medium">
						<span>Total</span>
						<span>
							{formatCurrency(total, "NGN")}
						</span>
					</div>
				</div>

				<div className="flex items-center gap-2 text-sm text-gray-500">
					<Clock className="h-4 w-4" />
					<span>Expires in 23:59:59</span>
				</div>

				<Button className="w-full" size="lg" onClick={() => handleNext()}>
					Review items
				</Button>
			</div>
		</>
	);
}
